import React, { useEffect, useState } from 'react'
import {useLocation, useNavigate} from 'react-router';
import useCorsi from '../../hooks/useCorsi';
import useContenutiCorso from '../../hooks/useContenutiCorso';
import CardLoadingPage from '../../components/CardLoadingPage/CardLoadingPage';
import CustomModal from '../../components/CustomModal/CustomModal';
import { Dropdown, Spinner, Tab, Tabs } from 'react-bootstrap';
import useAree from '../../hooks/useAree';
import useMediaQuery from '../../hooks/useMediaQuery';
import 'rc-tree/assets/index.css';
import CustomTree from '../../components/CustomTree/CustomTree';
import styles from './AggiungiContenutiCorsoPage.module.scss';
import CustomSlider from '../../components/CustomSlider/CustomSlider';
import ContenutoManager from '../../components/ContenutoManager/ContenutoManager';
import { alertService } from '../../services/AlertService';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import UtilityService from '../../services/UtillityServices/UtilityService';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import ComebackArrow from '../../components/ComebackArrow/ComebackArrow';

const AggiungiContenutiCorsoPage = () => {
  const {
    createAreaOrSottoarea,
    loadingStateAreeOrSottoaree,
    showModalContenutoAree,
    setShowModalContenutoAree,
    getAreeOrSottoareeByIdCorso,
    updateAreaOrSottoarea,
    setModalStateAree,
    deleteAreaOrSottoarea,
    modalStateAree,
  } = useAree();
  
  const {
    loadingStateContenutiCorso,
    createContenuto,
    findContenutiByParams,
    cloneContenuto
  } = useContenutiCorso();

  const location = useLocation();
  const corsoData = location.state && location.state.createdCorso;
  const [selectedCorso, setSelectedCorso] = useState(null);
  const [selectedItemDropdown, setItemDropdown] = useState("");
  const [formData, setFormData] = useState({});
  const [selectedAreaOrSottoarea, setSelectedAreaOrSottoarea] = useState(null);
  const [selectedContenutoObbligatorio, setSelectedContenutoObbligatorio] = useState(null);
  const [aree, setAree] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [selectedNodeTree, setSelectedNodeTree] = useState([]);
  const [selectedContenuto, setSelectedContenuto] = useState(null);
  const [inputAreaValue, setInputAreaValue] = useState();
  const [isConfirmDeleteStateArea, setIsConfirmDeleteStateArea] = useState(false);
  const [isSelectedOptionalContenuto, setIsSelectedOptionalContenuto] = useState(false);
  const [formDataFilterContenuti, setFormDataFilterContenuti] = useState({});
  const [contenutiCorso, setContenutiCorso] = useState([]);
  const [realod, setReload] = useState(false);
  const isMax600px = useMediaQuery('(max-width: 600px)');
  const [selectedContentContenuti, setSelectedContentContenuti] = useState(null);
  const [selectedPageContenuti, setSelectedPageContenuti] = useState(1);
  const [totalPagesContenuti, setTotalPagesContenuti] = useState(1);
  const [filteredContenuti, setFilteredContenuti] = useState([]);
  const navigate = useNavigate();
  const userLoggedIn = useSelector(state => state.user?.userData);
  const [isInitialized, setIsInitialized] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState('pdf');

  useEffect(() => {
    if(contenutiCorso?.length > 0) {
      const savedContenutoId = localStorage.getItem('selectedContenutoId');
      if(savedContenutoId) {
        const savedContenuto = contenutiCorso?.find(c => c.id_contenuto === parseInt(savedContenutoId));
        if(savedContenuto) {
          setSelectedContenuto(savedContenuto);
        }
      }
    }
  }, [contenutiCorso]);

  useEffect(() => {
    return () => {
      localStorage.removeItem('openFolders');
      localStorage.removeItem('selectedContenutoId');
    };
  }, []);

  useEffect(() => {
    if (isInitialized) {
      onFilteredTableContenuti();
    }
  }, [selectedPageContenuti])

  useEffect(() => {

    if(corsoData) {
      setIsInitialized(true)
      setSelectedCorso(corsoData)
      return
    }
    navigate("/corsi")
  },[])

  useEffect(() => {
      const convertedTreeData = convertToTreeData(aree, contenutiCorso);
      setTreeData(convertedTreeData);
  }, [aree]);

  useEffect(() => {
      setSelectedAreaOrSottoarea(selectedNodeTree)
  },[selectedNodeTree])

  useEffect(() => {
    if(selectedCorso) {
        printAllAree();
    }
  },[selectedCorso, realod])

  useEffect(() => {
    if(!showModalContenutoAree) {
      setFormData({})
    }
  },[showModalContenutoAree])

  const printAllAree = async () => {
    let objContenuti = {
      filtri: {
        id_corso: selectedCorso?.id_corso
      },
    };
    const fetchContenuti = await findContenutiByParams(objContenuti);
    const contenuti = fetchContenuti?.data.filter(contenuto => contenuto?.id_contenuto_principale === null)
    setContenutiCorso(contenuti);
    const objAree = {id_corso: selectedCorso?.id_corso}
    const fetchAree = await getAreeOrSottoareeByIdCorso(objAree);
    setAree(fetchAree)
  }

  
  const handlePageChangeContenuti = (page) => {
    setSelectedPageContenuti(page);
  };
  

  const onFilteredTableContenuti = async () => {
    let obj = {
        filtri: {
            ...formDataFilterContenuti,
        },
        limite: 4,
        pagina: selectedPageContenuti ?? 1,
    }
    const res = await findContenutiByParams(obj);
    const countPagination = Math.ceil(res?.count / obj.limite);
    setFilteredContenuti(res?.data);
    setTotalPagesContenuti(countPagination);
    if(res?.data?.length === 0){
      setSelectedPageContenuti(1)
      }
  }
  
  const handleCardClick = (contenuto) => {
    setSelectedContentContenuti(contenuto);
  };

  const handleCloseModal = () => {
    setShowModalContenutoAree(false)
    setModalStateAree(state => ({
      ...state,
      showModalUpdateAreaOrSottoarea: false,
    }));
    setIsConfirmDeleteStateArea(false)
  }

    const handleInputAreaChange = (e) => {
      setInputAreaValue(e.target.value);
    };


  const openModalCreateContenuto = (name) => {
    if((name === "sottoarea" || name === "testo-immagini" || name === "audio-video" || name === "duplica"  || name === "documenti") && aree?.length === 0) {
      alertService.warn(`Crea un'area per poter associare i contenuti`, {autoClose: true});
      return
    }

    setShowModalContenutoAree(true);
    setItemDropdown(name);
  }

  const closeModalCreateContenuto = () => {
    setShowModalContenutoAree(false);
    setSelectedContentContenuti(null);
    setFilteredContenuti(null);
  }

  const handleAreaChange = (event) => {
    setSelectedAreaOrSottoarea(event.target.value);
  }
  const handleContenutoObbligatorioChange = (event) => {
    setSelectedContenutoObbligatorio(event.target.value);
  }

  const handleFormChange = e => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const createContenutoCorso = async () => {
    if(selectedItemDropdown === "area") {
      if(formData?.area?.trim() === "") {
        alertService.warn("Inserisci un'area", {autoClose: true});
        return;
      }
      const obj = {
        titolo: formData?.area,
        eliminato: "0",
        id_corso: selectedCorso.id_corso
        }
      const res = await createAreaOrSottoarea(obj, "Area")
      if(res?.id){
        printAllAree()
      }
    }
    if(selectedItemDropdown === "sottoarea") {
      if(formData?.sottoarea?.trim() === ""){
        alertService.warn("Inserisci una sottoarea", {autoClose: true});
        return;
      }
      if(!selectedAreaOrSottoarea || selectedAreaOrSottoarea?.length === 0){
        alertService.warn("Seleziona un'area", {autoClose: true});
        return;
      }
      const obj = {
        titolo: formData?.sottoarea,
        eliminato: "0",
        id_corso: selectedCorso.id_corso,
        id_area_padre: selectedAreaOrSottoarea
        }
        const res = await createAreaOrSottoarea(obj, "Sottoarea")
        if(res?.id){
          printAllAree()
          setSelectedAreaOrSottoarea([]);
        }
    }

    
    if(selectedItemDropdown === "testo-immagini" || selectedItemDropdown === "documenti" || selectedItemDropdown === "audio-video" || selectedItemDropdown === "test") {
      if (!formData.titolo?.trim()) {
        alertService.warn('Il titolo è obbligatorio', { autoClose: true });
        return;
      }
      if(!selectedAreaOrSottoarea || selectedAreaOrSottoarea?.length === 0){
        alertService.warn("Seleziona un'area", {autoClose: true});
        return;
      }
      let type;
      if(selectedItemDropdown === "testo-immagini") {
        type = "testo-immagini"
      } else if (selectedItemDropdown === "documenti") {
        type = selectedDocType
      } else if (selectedItemDropdown === "audio-video"){
        type = "audio-video"
      } else if (selectedItemDropdown === "test") {
        type = "test"
      }

      let data = {
        titolo: formData?.titolo,
        eliminato: "0",
        id_corso: selectedCorso.id_corso,
        tipo_contenuto: type,
        opzionale: isSelectedOptionalContenuto ? "1" : "0",
        peso_orario: (isSelectedOptionalContenuto == "0") ? "1" : "0",
        id_area: selectedAreaOrSottoarea,
       }

      if(selectedContenutoObbligatorio !== "") {
        data = {
          ...data,
          id_contenuto_propedeutico: selectedContenutoObbligatorio
        }
      } else {
        setSelectedContenutoObbligatorio(null);
      }

      const res = await createContenuto(data)
      if(res?.id){
        setSelectedAreaOrSottoarea([])
        setIsSelectedOptionalContenuto(false)
        handleCloseModal();
        printAllAree()
      }
    }

  if(selectedItemDropdown === "duplica") {
    if(!selectedContentContenuti?.id_contenuto || !selectedAreaOrSottoarea || Array.isArray(selectedAreaOrSottoarea)) {
      alertService.warn(`Seleziona un contenuto ed un'area`, {autoClose: true});
      return
    }
    const obj = {
      id_contenuto: selectedContentContenuti?.id_contenuto,
      id_corso: selectedContentContenuti?.id_corso,
      id_area_target: selectedAreaOrSottoarea,
      id_corso_target: selectedCorso?.id_corso,
    }
    const res = await cloneContenuto(obj)
    if(res){
      handleCloseModal();
      printAllAree()
    }
  }

  }

  const handleCheckboxChange = (isChecked) => {
    setIsSelectedOptionalContenuto(isChecked);
  };

  const renderBodyModal = ({ name }) => {
    if (name === "area") {
      return (
        <>
          <p>Titolo dell'area</p>
          <input
            type="text"
            name="area"
            value={formData.area || ""}
            onChange={handleFormChange}
            placeholder="Titolo dell'area"
            className="form-control"
          />
        </>
      );
    } else if (name === "sottoarea") {
      return (
        <>
        {!loadingStateAreeOrSottoaree.isLoadingAreeOrSottoareeByIdCorso ? (
          <>
            <p>Titolo della sottoarea</p>
            <input
              type="text"
              name="sottoarea"
              value={formData.sottoarea || ""}
              onChange={handleFormChange}
              placeholder="Titolo della sottoarea"
              className="form-control"
            />
            <p className='mt-3'>Seleziona l'area a cui associare la sottoarea</p>
            <select className="form-control" onChange={handleAreaChange}>
              <option value="">Seleziona un'area</option>
              {aree?.map((area) => (
                <option key={area.id_area} value={area.id_area}>
                  {area.titolo}
                </option>
              ))}
            </select>
          </>
        ) : (
          <div className='m-auto text-center'>
          <p>Caricando le aree...</p>
          <Spinner animation="border" role="status">
          <span className="visually-hidden">Caricamento...</span>
        </Spinner>
        </div>
        )
      }
        </>
      );
    } else if(name === "testo-immagini" || name === "documenti"  || selectedItemDropdown === "audio-video") {
        return (
          <>
          {!loadingStateAreeOrSottoaree.isLoadingAreeOrSottoareeByIdCorso ? (
            <>
            <span className='mb-1'>Titolo del contenuto</span>
            <input type='text' name="titolo" value={formData.titolo || ""} onChange={handleFormChange} className='form-control' placeholder='Titolo del contenuto'/>
            <div className='mt-3'>
            <CustomSlider
              handleSliderChange={handleCheckboxChange}
              labelText="Contenuto opzionale?"
              />
            </div>
            <div className='mt-3'>
            <span style={{wordBreak: "break-word"}} className='mb-1'>Seleziona un contenuto obbligatorio</span>
            <select className="form-control" onChange={handleContenutoObbligatorioChange}>
              <option value="">Nessun contenuto</option>
              {contenutiCorso?.map((contenuto) => (
                <option key={contenuto.id_contenuto} value={contenuto.id_contenuto}>
                  {contenuto.titolo}
                </option>
              ))}
            </select>
            </div>
            <div className='mt-3'>
            <span className='mb-1'>Seleziona l'area a cui associare il contenuto</span>
            <select className="form-control" onChange={handleAreaChange}>
              <option value="">Seleziona un'area</option>
              {aree?.map((area) => (
                <option key={area.id_area} value={area.id_area}>
                  {area.titolo}
                </option>
              ))}
            </select>
            </div>

            {
              name === "documenti" && (
                <div className='mt-3'>
                <span className='mb-1'>Seleziona il tipo di documento</span>
                <select 
                  className="form-control" 
                  onChange={(e) => setSelectedDocType(e.target.value)}
                  value={selectedDocType}
                >
                  <option value="pdf">Pdf</option>
                  <option value="documento-testo">Documento di testo</option>
                </select> 
            </div>
              )

            }
            </>
              ) : (
              <div className='m-auto text-center'>
              <p>Caricando le aree...</p>
              <Spinner animation="border" role="status">
              <span className="visually-hidden">Caricamento...</span>

            </Spinner>
            </div>
              )}
          </>
        )
    } else if(name === "duplica") {
      return (
      <>
   <span className='mb-1'>Cerca un contenuto esistente da duplicare</span>
      <CustomFilterTable 
        formDataFilter={formDataFilterContenuti}
        setFormDataFilter={setFormDataFilterContenuti}
        onFilteredTable={onFilteredTableContenuti}
        isModalView={true}
        isLoadingData={loadingStateContenutiCorso.isLoadingFindContenutiByParams}
        itsOneField={true}
        searchNodeType={
         [
          {nodeType: "input", name: "titolo"},
        ]
      }
      />
          <div className='row'>
          {filteredContenuti?.map(contenuto => (
          <div className='col-sm-12 col-md-6 my-2' key={contenuto?.id_contenuto}>
            <div
              className={`card p-2 ${selectedContentContenuti?.id_contenuto === contenuto.id_contenuto ? 'border border-success' : ''}`}
              role='button'
              onClick={() => handleCardClick(contenuto)}
            >
              <span>{UtilityService.generateIconContenuti(contenuto)} {contenuto?.titolo}</span>
            </div>
          </div>
          
        ))}
        <div className='my-3 d-flex justify-content-end'>
          {
            filteredContenuti && (
              <CustomPagination
                totalPages={totalPagesContenuti}
                selectedPage={selectedPageContenuti}
                handlePageChange={handlePageChangeContenuti} 
                />
            )
          }
        </div>
      </div>
      {selectedContentContenuti && (
        <div>
          <h5>Contenuto Selezionato:</h5>
          <div className='card p-2'>
            <span>{UtilityService.generateIconContenuti(selectedContentContenuti)}  {selectedContentContenuti?.titolo}</span>
          </div>
        </div>
      )}
      <div className='mt-3'>
      <span className='mb-1'>Seleziona l'area a cui associare il contenuto</span>
      <select className="form-control" onChange={handleAreaChange}>
        <option value="">Seleziona un'area</option>
        {aree?.map((area) => (
          <option key={area.id_area} value={area.id_area}>
            {area.titolo}
          </option>
        ))}
      </select>
      </div>
      </>
      )
    } else if(name === "test") {
      return (
        <>
          {!loadingStateAreeOrSottoaree.isLoadingAreeOrSottoareeByIdCorso ? (
            <>
            <span className='mb-1'>Titolo del test</span>
            <input type='text' name="titolo" value={formData.titolo || ""} onChange={handleFormChange} className='form-control' placeholder='Titolo del contenuto'/>
            <div className='mt-3'>
            <span style={{wordBreak: "break-word"}} className='mb-1'>Seleziona un contenuto obbligatorio</span>
            <select className="form-control" onChange={handleContenutoObbligatorioChange}>
              <option value="">Nessun contenuto</option>
              {contenutiCorso?.map((contenuto) => (
                <option key={contenuto.id_contenuto} value={contenuto.id_contenuto}>
                  {contenuto.titolo}
                </option>
              ))}
            </select>
            </div>
            <div className='mt-3'>
            <span className='mb-1'>Seleziona l'area a cui associare il test</span>
            <select className="form-control" onChange={handleAreaChange}>
              <option value="">Seleziona un'area</option>
              {aree?.map((area) => (
                <option key={area.id_area} value={area.id_area}>
                  {area.titolo}
                </option>
              ))}
            </select>
            </div>
            </>
              ) : (
              <div className='m-auto text-center'>
              <p>Caricando le aree...</p>
              <Spinner animation="border" role="status">
              <span className="visually-hidden">Caricamento...</span>
            </Spinner>
            </div>
              )}
        </>
      )
    } else {
      return null;
    }
  };

  const convertToTreeData = (data, contenutiCorso) => {
    const map = {};
    const treeData = [];

    data?.forEach((node) => {
      map[node.id_area] = { ...node, children: [], contenuti: [], key: node.id_area };
    });

    contenutiCorso?.forEach((contenuto) => {
        if (map[contenuto?.id_area] && !contenuto.id_contenuto_principale) {
            map[contenuto?.id_area].contenuti.push(contenuto);
        }
    });

    data?.forEach((node) => {
        if (node.id_area_padre === 0) {
            treeData.push(map[node.id_area]);
        } else if (map[node.id_area_padre]) {
            map[node.id_area_padre].children.push(map[node.id_area]);
        } else {
            console.error(`Nodo padre non trovato per l'area con ID ${node.id_area}`);
        }
    });
    return treeData;
};


  const renderBodyUpdateAree = (nodo) => (
    <>
    <div className='container'>
        <div className='row'>
            <div className='col-12 my-2'>
            <span className='small text-muted d-block mb-1'><b>{`Modifica ${(nodo?.id_area_padre === 0) ? "Area" : "Sottoarea"}`}</b></span>
               <input name="area" value={inputAreaValue} onChange={handleInputAreaChange} className="form-control" type="text" placeholder={`Modifica ${(nodo?.id_area_padre === 0) ? "Area" : "Sottoarea"}`}/>
            </div>
        </div>
    </div>
    </>
  )


  const onUpdateAreaOrSottoarea = async () => {
    if(inputAreaValue?.trim() === "") {
      alertService.warn("Inserisci un titolo", {autoClose: true});
      return;
    }
    const obj = {
      titolo: inputAreaValue,
      id_area: selectedNodeTree.id_area,
      id_area_padre: selectedNodeTree.id_area_padre,
      eliminato: "0"
    }
    await updateAreaOrSottoarea(obj)
    printAllAree();
  }

  const onDeleteAreaOrSottoarea = async () => {
    const obj = {id_area: selectedAreaOrSottoarea?.id_area};
    const res = await deleteAreaOrSottoarea(obj);
    if(res?.ok) {
      printAllAree();
      setIsConfirmDeleteStateArea(false);
    }
  }

  return (
    <>

  <div className={`card custom-card w-100 shadow`} style={{ minHeight: '800px' }}>
  <div className={`${!isMax600px ? "p-5" : ""}`}>
    <div className='container'>
      <div className='row'>
      <ComebackArrow path={"/gestione-corsi"} />
      <div className="d-flex justify-content-between custom-card-header">
                <div className="d-flex gap-3 custom-card-title my-2">
                  <div className={`custom-icon-container`}>
                    {selectedCorso?.immagine_corso ? 
                     <img src={selectedCorso?.immagine_corso} className='custom-icon' alt='immagine corso'/> : 
                     <i className={`bi custom-icon bi-mortarboard fs-2`}></i>}
                  </div>
                  <div className="align-self-center">
                    <span className="fs-4 d-block">
                      <i>
                        <b>{selectedCorso?.denominazione}</b>
                      </i>
                    </span>
                  </div>
                </div>
              </div>
                <div className='align-self-center my-2 text-end'>
                <Dropdown autoClose={true} className='align-self-center' >
                  <Dropdown.Toggle variant="primary" id="dropdown-autoclose-false" disabled={!selectedCorso}>
                    Aggiungi contenuti
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="custom-dropdown-menu">
                    <div className='container'>
                      <div className='row'>
                        <div className='col-sm-12 col-md-4'>
                          <h6><b>ORGANIZZAZIONE</b></h6>
                          <hr />
                          {
                            (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.COURSE_DESIGNER ||  userLoggedIn?.role === ROLES.DEVELOPER) && (
                              <>
                              <span onClick={() => openModalCreateContenuto("area")}><i className="bi bi-folder-fill"></i> Area</span>
                              <span onClick={() => openModalCreateContenuto("sottoarea")}><i className="bi bi-folder2-open"></i> Sottoarea</span>
                              </>

                            )
                          }
                          <span onClick={() => openModalCreateContenuto("duplica")}><i className='bi-file-earmark'></i> Duplica contenuti</span>
                        </div>
                        <div className='col-sm-12 col-md-4'>
                        <h6><b>CONTENUTI</b></h6>
                          <hr />
                          <span onClick={() => openModalCreateContenuto("testo-immagini")}><i className='bi bi-file-earmark-font'></i> Testo-immagini</span>
                          <span onClick={() => openModalCreateContenuto("audio-video")}><i className='bi-file-earmark-play'></i> Audio-video</span>
                          <span onClick={() => openModalCreateContenuto("documenti")}><i className='bi-file-earmark-pdf'></i> Documenti</span>
                        </div>
                        <div className='col-sm-12 col-md-4'>

                          <h6><b>ESERCIZI</b></h6>
                          <hr />
                          <span onClick={() => openModalCreateContenuto("test")}>Test</span>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
                </div>

        <div className='col-sm-12'>
        <div>
          <>
            {selectedCorso ? (
              <div className='row'>
                 { (loadingStateContenutiCorso.isLoadingFindContenutiByParams || loadingStateAreeOrSottoaree.isLoadingAreeOrSottoareeByIdCorso) ?  (
                    <div className='m-auto text-center mt-3'>
                      <p className='fs-4'>Caricando i contenuti...</p>
                      <Spinner animation="border" role="status">
                      <span className="visually-hidden">Caricamento...</span>
                    </Spinner>
                  </div>
                 ) : (
                  (treeData?.length > 0) ? (
                    <div className='mt-3'>
                      <div className={`row ${styles.contentRow}`}>
                        <div className={`col-lg-3 ${styles.treeContainer}`}>
                          <CustomTree
                           areas={treeData}
                           setSelectedNodeTree={setSelectedNodeTree}
                           setModalStateAree={setModalStateAree}
                           setInputAreaValue={setInputAreaValue}
                           setSelectedContenuto={setSelectedContenuto}
                           />
                        </div>
                        <div style={{paddingBottom: isMax600px && "100px"}} className={`col-lg-9 ${styles.contentContainer}`}>
                          <ContenutoManager
                            selectedContenuto={selectedContenuto}
                            setReload={setReload}
                            printAllAree={printAllAree}
                            setSelectedContenuto={setSelectedContenuto}
                            contenutiCorso={contenutiCorso}
                            courseData={selectedCorso}
                          />
                        </div>
                  </div>
                </div>
                ) : (
                      <p className='fs-4 mt-5 text-center'>Il corso selezionato non ha contenuti attivi</p>
                ))}
               </div>
            ) : (
              <p className='fs-4 mt-5 text-center'>Seleziona un corso per visualizzarne il contenuto</p>
            )}
          </>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    <CustomModal
      headerText={`${selectedItemDropdown === "duplica" ? "Duplica contenuto" : `Crea ${selectedItemDropdown}`}`}
      show={showModalContenutoAree}
      onHide={closeModalCreateContenuto}
      onUndoChanges={closeModalCreateContenuto}
      body={renderBodyModal({name: selectedItemDropdown})}
      onSave={createContenutoCorso}
      btnText={"Salva"}
      closeButton={true}
      isLoading={loadingStateAreeOrSottoaree.isLoadingAreaOrSottoareaCreating || loadingStateContenutiCorso.isLoadingContenutoCreating}
    />

    <CustomModal
      headerText={`Modifica ${(selectedNodeTree?.id_area_padre === 0) ? "Area" : "Sottoarea"}`}
      show={modalStateAree.showModalUpdateAreaOrSottoarea}
      onHide={handleCloseModal}
      body={renderBodyUpdateAree(selectedNodeTree)}
      onSave={onUpdateAreaOrSottoarea}
      btnText={"Salva modifica"}
      closeButton={true}
      isLoading={loadingStateAreeOrSottoaree.isLoadingAreaOrSottoareaUpdate}
      footerStyle={"d-flex justify-content-between"}
      dFlexBtn={true}
      isAlsoDeleteModal={true}
      isConfirmDeleteStateArea={isConfirmDeleteStateArea}
      setIsConfirmDeleteStateArea={setIsConfirmDeleteStateArea}
      onDeleteAreaOrSottoarea={onDeleteAreaOrSottoarea}
      isLoadingAreaOrSottoareaDelete={loadingStateAreeOrSottoaree.isLoadingAreaOrSottoareaDelete}
    />
    </>
  )
}

export default AggiungiContenutiCorsoPage;
